/* src/app/components/submission-device-characteristics/submission-device-characteristics.component.scss */
/*# sourceMappingURL=submission-device-characteristics.component.css.map */
